<template>
  <div>
    <!-- SINGLE QUESTION POLL -->
    <div v-if="!poll.multiple">
      <v-radio-group
        v-bind:value="value"
        @change="$emit('input', $event)"
        :mandatory="false"
      >
        <v-radio
          class="poll-item"
          v-for="(answer, index) in poll.answers"
          v-bind:key="index"
          :label="answer.title"
          :value="answer._id"
        ></v-radio>
      </v-radio-group>
    </div>
    <!-- MULTIPLE QUESTION POLL -->
    <div v-if="poll.multiple">
      <v-checkbox
        @change="handleChange"
        multiple
        class="poll-item"
        v-for="(answer, index) in poll.answers"
        v-bind:key="index"
        v-model="checkedItems"
        :label="answer.title"
        :value="answer._id"
        :checked="checkedItems.includes(answer._id)"
        :disabled="handleDisabled(answer)"
      ></v-checkbox>

      <span v-show="poll.multipleMax > 0"
        >Select up to {{ poll.multipleMax }} answer(s)</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["value", "poll"],
  data() {
    return {
      abstain: false
    };
  },
  computed: {
    checkedItems: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      }
    }
  },

  methods: {
    handleDisabled(answer) {
      // if abstain is selected disable all other options
      if (this.abstain && !this.checkedItems.includes(answer._id)) {
        return true;
      }
      // if min/max is reached disable all options that have not been checked.
      return (
        this.poll.multipleMax > 0 &&
        this.checkedItems.length >= this.poll.multipleMax &&
        !this.checkedItems.includes(answer._id)
      );
    },
    handleChange(checked) {
      this.abstain = false;
      // if one of the options is labeled "Abstain" uncheck all other options
      // and set the abstain flag to true
      const abstain = this.poll.answers.find((answer) =>
        answer.title.match(/Abstain|None of the Above|No Vote/i)
      );
      if (abstain) {
        if (checked.includes(abstain._id)) {
          this.checkedItems = [abstain._id];
          this.abstain = true;
        }
      }
    }
  }
};
</script>
<style>
.poll-item {
  background-color: #eee;
  opacity: 0.8;
  border: 1px solid #ccc;
  color: #fff;
  border-radius: 5px;
  padding: 5px 0 5px 8px;
  margin: 4px 0 4px 0;
  height: auto;
}
.poll-item label {
  color: #fff;
  padding: 5px 0px 5px 4px;
}

.poll-item .v-messages {
  display: none;
}

.poll-item .v-input__slot {
  margin-bottom: 0;
}

.poll-item .v-input .v-label {
  line-height: 18px;
  font-size: 80%;
}
</style>
